export const defaultErrorBoundaryHandler = (error: any): boolean => {
  const status = (error?.response as Response)?.status
  return !!(status && [402, 401, 403].includes(Number(status)))
}
